import service from "./service";

async function getPriceInfo(priceId) {
  try {
    const res = await service.getPriceInfo(priceId);
    return res;
  } catch (error) {
    return null;
  }
}

async function getPriceHistories(payload) {
  try {
    const res = await service.getPriceHistories(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function priceSetting(payload) {
  try {
    const res = await service.priceSetting(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getBasicContract(payload) {
  try {
    const res = await service.getBasicContract(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function basicContract(payload) {
  try {
    const res = await service.basicContract(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getContracts(payload) {
  try {
    const res = await service.getContracts(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getAbbreviatedContracts(payload) {
  try {
    const res = await service.getAbbreviatedContracts(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function abbreviatedContract(payload) {
  try {
    const res = await service.abbreviatedContract(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getTaskLatestPrices(payload) {
  try {
    const res = await service.getTaskLatestPrices(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function contractRetransmit(contractId) {
  try {
    const res = await service.contractRetransmit(contractId);
    return res;
  } catch (error) {
    return null;
  }
}

async function createPayments(payload) {
  try {
    const res = await service.createPaymemts(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getPriceGroups(payload) {
  try {
    const res = await service.getPriceGroups(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getPriceGroupDetail(priceGroupId) {
  try {
    const res = await service.getPriceGroupDetail(priceGroupId);
    return res;
  } catch (error) {
    return null;
  }
}

async function createPriceGroup(payload) {
  try {
    const res = await service.createPriceGroup(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function deletePriceGroup(priceGroupId) {
  try {
    const res = await service.deletePriceGroup(priceGroupId);
    return res;
  } catch (error) {
    return null;
  }
}

async function updateTaskPriceGroup(taskId, payload) {
  try {
    const res = await service.updateTaskPriceGroup(taskId, payload);
    return res;
  } catch (error) {
    return null;
  }
}

export default {
  getPriceInfo,
  getPriceHistories,
  priceSetting,
  getBasicContract,
  basicContract,
  getContracts,
  getAbbreviatedContracts,
  abbreviatedContract,
  getTaskLatestPrices,
  contractRetransmit,
  createPayments,
  getPriceGroups,
  getPriceGroupDetail,
  createPriceGroup,
  deletePriceGroup,
  updateTaskPriceGroup,
};
